/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button.demo-reset[_ngcontent-%COMP%]{position:fixed;bottom:50px;right:50px;width:80px;height:80px;border-radius:40px;color:#fff;background:#8c0000;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);cursor:pointer}"];
export { styles as styles };
